export default "__VITE_ASSET__Cef3RrEg__"